import Vuex from "vuex";
import Vue from "vue";
import axios from "axios";

Vue.use(Vuex);

export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const USER_REQUEST = "USER_REQUEST";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_ERROR = "USER_ERROR";

export default new Vuex.Store({
  state: {
    sysNombre: "",
    sysDireccionLocalidad: "",
    sysTelefonoEmail: "",
    sysId_TipoIva: "",
    sysAlicuotaIvaBasico: 0,
    sysAlicuotaIvaDiferencial: 0,
    sysForegroundColor: "",
    sysBackgroundColor: "",
    appMenu: "", // El menú elegido por el usuario.
    appTitulo: "", // El nombre del Punto de Venta del menú elegido.
    appId_PuntoVenta: 0, // El Punto de Venta elegido por el usuario.
    nombreUsuario: "",
    nombreUsuarioEmpleado: "",
    nombreUsuarioEmpresa: "",
    nombreRol: "",
    token: localStorage.getItem("user-token") || "",
    status: "",
    rol: {}
  },
  getters: {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
    getRol: state => state.rol,
    isRolLoaded: state => !!state.rol.name,
    VUE_APP_ROOT_API: () => window.VUE_APP_ROOT_API,
    APP_BACKGROUND_IMAGE_URL: () => window.APP_BACKGROUND_IMAGE_URL
  },
  mutations: {
    setearSysNombre(state, valor) {
      state.sysNombre = valor;
    },
    setearSysDireccionLocalidad(state, valor) {
      state.sysDireccionLocalidad = valor;
    },
    setearSysTelefonoEmail(state, valor) {
      state.sysTelefonoEmail = valor;
    },
    setearSysId_TipoIva(state, valor) {
      state.sysId_TipoIva = valor;
    },
    setearSysAlicuotaIvaBasico(state, valor) {
      state.sysAlicuotaIvaBasico = valor;
    },
    setearSysAlicuotaIvaDiferencial(state, valor) {
      state.sysAlicuotaIvaDiferencial = valor;
    },
    setearSysForegroundColor(state, valor) {
      state.sysForegroundColor = valor;
    },
    setearSysBackgroundColor(state, valor) {
      state.sysBackgroundColor = valor;
    },
    setearAppMenu(state, valor) {
      state.appMenu = valor;
    },
    setearAppTitulo(state, valor) {
      state.appTitulo = valor;
    },
    setearAppId_PuntoVenta(state, valor) {
      state.appId_PuntoVenta = valor;
    },
    [AUTH_REQUEST]: state => {
      state.status = "loading";
    },
    [AUTH_SUCCESS]: (state, token) => {
      state.status = "success";
      state.token = token;
    },
    [AUTH_ERROR]: state => {
      state.status = "error";
    },
    [USER_REQUEST]: (state, usuario) => {
      state.status = "loading";
      localStorage.setItem("user-name", usuario.Nombre);
    },
    [USER_SUCCESS]: (state, usuario) => {
      state.status = "success";
      Vue.set(state, "nombreUsuario", usuario.Nombre);
      Vue.set(state, "nombreUsuarioEmpleado", usuario.NombreEmpleado);
      Vue.set(state, "nombreUsuarioEmpresa", usuario.NombreEmpresa);
      Vue.set(state, "nombreRol", usuario.NombreRol);
    },
    [USER_ERROR]: state => {
      state.status = "error";
      localStorage.removeItem("user-token"); // if the request fails, remove any possible user token if possible
      localStorage.removeItem("user-name");
    },
    [AUTH_LOGOUT]: state => {
      state.rol = {};
      //mGuy: agregada para que funcione bien el Logout
      state.nombreUsuario = state.nombreUsuarioEmpleado = state.nombreRol = state.token =
        "";
      localStorage.removeItem("user-token"); // clear your user"s token from localstorage
      localStorage.removeItem("user-name");
    }
  },
  actions: {
    setearSysNombre(context, valor) {
      context.commit("setearSysNombre", valor);
    },
    setearSysDireccionLocalidad(context, valor) {
      context.commit("setearSysDireccionLocalidad", valor);
    },
    setearSysTelefonoEmail(context, valor) {
      context.commit("setearSysTelefonoEmail", valor);
    },
    setearSysId_TipoIva(context, valor) {
      context.commit("setearSysId_TipoIva", valor);
    },
    setearSysAlicuotaIvaBasico(context, valor) {
      context.commit("setearSysAlicuotaIvaBasico", valor);
    },
    setearSysAlicuotaIvaDiferencial(context, valor) {
      context.commit("setearSysAlicuotaIvaDiferencial", valor);
    },
    setearSysForegroundColor(context, valor) {
      context.commit("setearSysForegroundColor", valor);
    },
    setearSysBackgroundColor(context, valor) {
      context.commit("setearSysBackgroundColor", valor);
    },
    setearAppMenu(context, valor) {
      context.commit("setearAppMenu", valor);
    },
    setearAppTitulo(context, valor) {
      context.commit("setearAppTitulo", valor);
    },
    setearAppId_PuntoVenta(context, valor) {
      context.commit("setearAppId_PuntoVenta", valor);
    },
    [AUTH_REQUEST]: ({ commit }, user) => {
      return new Promise((resolve, reject) => {
        // The Promise used for router redirect in login
        commit(AUTH_REQUEST);
        axios
          .post(window.VUE_APP_ROOT_API + "Usuario/Validar", user)
          .then(resp => {
            if (resp.data.Resultado == "OK") {
              const usuario = resp.data;
              localStorage.setItem("user-token", usuario.Token); // store the token in localstorage
              axios.defaults.headers.common["Authorization"] = usuario.Token; // add the axios default header
              commit(AUTH_SUCCESS, usuario.Token);

              // dispatch(USER_REQUEST, usuario); // you have your token, now log in your user :)
              commit(USER_REQUEST, usuario);
              commit(USER_SUCCESS, usuario);

              resolve(resp);
            } else {
              commit(AUTH_LOGOUT);
              // remove the axios default header
              delete axios.defaults.headers.common["Authorization"];
              resolve(resp);
            }
          })
          .catch(err => {
            commit(AUTH_ERROR, err);
            reject(err);
          });
      });
    },
    [AUTH_LOGOUT]: ({ commit }) => {
      return new Promise(resolve => {
        commit(AUTH_LOGOUT);
        localStorage.removeItem("user-token"); // clear your user"s token from localstorage
        delete axios.defaults.headers.common["Authorization"]; // remove the axios default header
        resolve();
      });
    },
    [USER_REQUEST]: ({ commit, dispatch }, user) => {
      commit(USER_REQUEST, user);
      axios
        .get(window.VUE_APP_ROOT_API + "Usuario/BuscarPorNombre", {
          params: {
            nombre: user.Nombre
          }
        })
        .then(resp => {
          commit(USER_SUCCESS, resp.data);
        })
        .catch(() => {
          commit(USER_ERROR);
          // if resp is unauthorized, logout, to
          dispatch(AUTH_LOGOUT);
        });
    }
  }
});
